import createApi from './api';

export default class WorkingHoursService {
  constructor() {
    this.api = createApi({
      baseUrl: '/admin/work-schedule/',
      headers: {
        'Content-Type': 'application/json'
      },
    })
  }
  
  list() {
    return this.api.get('list');
  }

  get({ schedule_id }) {
    return this.api.get('get', { schedule_id });
  }

  listShifts({ schedule_id }) {
    return this.api.get('list-shifts', {
      schedule_id
    });
  }

  create(schedule) {
    return this.api.post('create', schedule);
  }

  update(schedule) {
    return this.api.post('update', schedule);
  }

  updateShifts({ schedule_id, shifts }) {
    return this.api.post('update-shifts', { schedule_id, shifts });
  }

  delete({ schedule_id }) {
    return this.api.delete('delete', { schedule_id });
  }
}